/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Native_Release_Strava_ConnectedInputs */

const en_us2_native_release_strava_connected = /** @type {(inputs: Native_Release_Strava_ConnectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Connected as ${i?.name}`)
};

const pt_br2_native_release_strava_connected = /** @type {(inputs: Native_Release_Strava_ConnectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conectado como ${i?.name}`)
};

const pt_pt2_native_release_strava_connected = /** @type {(inputs: Native_Release_Strava_ConnectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conectado como ${i?.name}`)
};

/** @type {(inputs: Native_Release_Strava_ConnectedInputs) => LocalizedString} */
const es_419_native_release_strava_connected = en_us2_native_release_strava_connected;

/** @type {(inputs: Native_Release_Strava_ConnectedInputs) => LocalizedString} */
const fr_fr2_native_release_strava_connected = en_us2_native_release_strava_connected;

/** @type {(inputs: Native_Release_Strava_ConnectedInputs) => LocalizedString} */
const de_de2_native_release_strava_connected = en_us2_native_release_strava_connected;

/** @type {(inputs: Native_Release_Strava_ConnectedInputs) => LocalizedString} */
const it_it2_native_release_strava_connected = en_us2_native_release_strava_connected;

/**
* | output |
* | --- |
* | "Connected as {name}" |
*
* @param {Native_Release_Strava_ConnectedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_strava_connected = /** @type {((inputs: Native_Release_Strava_ConnectedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Strava_ConnectedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_strava_connected(inputs)
	if (locale === "es-419") return es_419_native_release_strava_connected(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_strava_connected(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_strava_connected(inputs)
	if (locale === "de-DE") return de_de2_native_release_strava_connected(inputs)
	if (locale === "it-IT") return it_it2_native_release_strava_connected(inputs)
	return en_us2_native_release_strava_connected(inputs)
});
export { native_release_strava_connected as "native-release.strava_connected" }